















import {
  defineComponent, PropType, computed,
} from '@vue/composition-api';
import AccessoryCard from '~/components/marketplace/AccessoryCard.vue';
import { IStoryblokPage } from '~/types/storyblok';
import { useToggleDrawer } from '~/composables/useToggleDrawer';
import { transformShopifyProdId } from '~/selectors/selectors';

export default defineComponent({
  name: 'RelatedProducts',
  inheritAttrs: false,
  components: {
    AccessoryCard,
  },
  props: {
    products: {
      type: Array as PropType<IStoryblokPage[]>,
      required: true,
    },
  },
  setup(props) {
    // @ts-ignore
    const { $store } = useNuxtApp();

    const accessories = computed(() => props.products.map((acc) => {
      const item = acc?.content?.body[0]?.container[0]?.contentContainer[0];
      const oldId = acc?.content?.body[0]?.container[0]?.contentContainer[0]?.productName;

      return {
        slug: acc.full_slug,
        ...transformShopifyProdId({
          testShopifyId: item?.testShopifyId, prodShopifyId: item?.prodShopifyId, oldId, store: $store,
        }),
      };
    }));

    const { openDrawer } = useToggleDrawer();

    return {
      accessories,
      openDrawer,
    };
  },
});
